module.exports = __webpack_public_path__ + "img/AccountTreeOutlined.74174392.svg";